import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Dashboard/Navbar";
import Sidebar from "../../components/Dashboard/Sidebar";
import CreateSubject from "./Subject/CreateSubject";
import ViewSubject from "./Subject/ViewSubject";
import CreateQuestion from "./QuationManagement/CreateQuestion";
import ViewQuestion from "./QuationManagement/ViewQuestion";
import CreateNote from "./Note/CreateNote";
import ViewNotes from "./Note/ViewNotes";
import CreateFlash from "./Flash/CreateFlash";
import ViewFlash from "./Flash/ViewFlash";
import CreateModule from "./Module/CreateModule";
import ViewModule from "./Module/ViewModule";

const DashboardHome = () => {
  // Load selected menu from localStorage or default to dashboard
  const [selectedMenu, setSelectedMenu] = useState(
    localStorage.getItem('selectedMenu') || 'dashboard'
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      // On desktop, always show sidebar
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Save selected menu to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('selectedMenu', selectedMenu);
  }, [selectedMenu]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const renderContent = () => {
    const contentComponents = {

      addSubject: <CreateSubject onSubjectCreated={() => setSelectedMenu('subjectOverView')} />,
      subjectOverView: <ViewSubject />,
      addModule: <CreateModule onModuleCreated={() => setSelectedMenu('moduleOverView')} />,
      moduleOverView: <ViewModule />,
      addQuestion: <CreateQuestion onQuestionCreated={() => setSelectedMenu('questionOverview')} />,
      questionOverview: <ViewQuestion />,


      addNote: <CreateNote onNoteCreated={() => setSelectedMenu('noteOverview')} />,
      noteOverview: <ViewNotes />,
      // addFlash: <CreateFlash onFlashCreated={() => setSelectedMenu('flashOverview')} />,
      flashOverview: <ViewFlash />,
    };

    return contentComponents[selectedMenu] || (
      <div className="p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Welcome to the Dashboard</h1>
        <p className="text-gray-600">Select an option from the sidebar to get started.</p>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <DashboardCard 
            icon="📊" 
            title="Analytics" 
            description="View your dashboard analytics and statistics"
          />
          <DashboardCard 
            icon="📝" 
            title="Quick Actions" 
            description="Create new content or manage existing items"
          />
          <DashboardCard 
            icon="🔔" 
            title="Notifications" 
            description="Check your recent notifications and alerts"
          />
        </div>
      </div>
    );
  };

  const DashboardCard = ({ icon, title, description }) => (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
      <div className="text-2xl mb-2">{icon}</div>
      <h3 className="font-semibold text-gray-800">{title}</h3>
      <p className="text-sm text-gray-600 mt-1">{description}</p>
    </div>
  );

  return (
    <div className="flex flex-col md:flex-row h-screen bg-gray-50">
      {/* Navbar */}
      <Navbar 
        toggleSidebar={toggleSidebar} 
        navigate={navigate} 
        isMobile={isMobile}
        isSidebarOpen={isSidebarOpen}
      />

      {/* Sidebar */}
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        selectedMenu={selectedMenu}
        setSelectedMenu={setSelectedMenu}
        toggleSidebar={toggleSidebar}
        navigate={navigate}
        isMobile={isMobile}
      />

      {/* Main Content */}
      <main className={`flex-1 overflow-auto transition-all duration-300 ${isSidebarOpen ? 'ml-0 md:ml-10' : 'ml-0'}`}>
        <div className="flex items-center justify-center p-4 md:p-6 md:mt-24">
          <div className="bg-white rounded-lg shadow-sm p-4 md:p-6 w-full">
            {renderContent()}
          </div>
        </div>
      </main>

      {/* Overlay for mobile sidebar */}
      {isSidebarOpen && isMobile && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20"
          onClick={toggleSidebar}
        />
      )}
    </div>
  );
};

export default DashboardHome;